module.exports = [{
      plugin: require('/zeit/494fcb1b/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Hemneo Static","short_name":"hemneostatic","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"minimal-ui"},
    },{
      plugin: require('/zeit/494fcb1b/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
